const checkDateText = (dateText: string): string => {
  if (dateText === 'undefined') {
    return '';
  }
  return dateText;
};

export default checkDateText;
